<h2 mat-dialog-title>Log ind</h2>
<mat-dialog-content>
  <p>Før du kan foretage en booking, skal du logge ind på din konto.</p>
  <p>Har du ikke en konto endnu?</p>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="dialog-actions">
    <abook-button appearance="tonal" (clicked)="register()">Opret konto</abook-button>
    <abook-button appearance="filled" (clicked)="signIn()">Log ind</abook-button>
  </div>
</mat-dialog-actions>
